import React, { useState, useEffect } from "react";
import { 
  Modal, 
  Flex, 
  Text, 
  Button,
  Group 
} from "@mantine/core";
import zIndex from "../../designTokens/zIndex";
import { DateTimePicker } from "@mantine/dates";
import ThreadComposer from "./ThreadComposer";
import { useTranslation } from "react-i18next";

const EditPostModal = ({ 
  isOpen, 
  onClose, 
  editThreads,
  setEditThreads,
  editDateTime, 
  setEditDateTime, 
  loading, 
  onSave, 
  onDelete 
}) => {
  const { t } = useTranslation();

  // ThreadComposer에서 데이터 변경 처리
  const handleThreadsChange = (newThreads) => {
    setEditThreads(newThreads);
  };

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title={t("postThreads.editScheduledThread")}
      size="lg"
      zIndex={zIndex.modal}
    >
      <Flex direction="column" gap="md">
        {/* ThreadComposer 사용 */}
        <ThreadComposer
          threads={editThreads}
          onThreadsChange={handleThreadsChange}
          loading={loading}
          maxThreads={5}
        />

        <Text size="sm" weight={500}>
          예약 시간 수정
        </Text>
        <DateTimePicker
          placeholder="날짜와 시간 선택"
          value={editDateTime}
          onChange={setEditDateTime}
          disabled={loading}
          style={{ width: "100%" }}
          minDate={new Date()}
          popoverProps={{
            zIndex: zIndex.modal + 10, // 모달보다 높은 z-index 설정
            withinPortal: true // 포털을 사용하여 모달 밖에 렌더링
          }}
        />

        <Flex justify="space-between" align="center" mt="md" w="100%">
          <Button
            variant="outline"
            color="red"
            size="md"
            onClick={onDelete}
            loading={loading}
          >
            {t("common.delete")}
          </Button>

          <Group>
            <Button
              variant="subtle"
              size="md"
              onClick={onClose}
              disabled={loading}
            >
              {t("common.cancel")}
            </Button>
            <Button 
              size="md"
              color="dark"
              onClick={onSave} 
              loading={loading}
            >
              {t("common.save")}
            </Button>
          </Group>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default EditPostModal; 